/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Streetrequired1Inputs */

const en_streetrequired1 = /** @type {(inputs: Streetrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street is required`)
};

const de_streetrequired1 = /** @type {(inputs: Streetrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straßenadresse ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Street is required" |
*
* @param {Streetrequired1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const streetrequired1 = /** @type {((inputs?: Streetrequired1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Streetrequired1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_streetrequired1(inputs)
	return de_streetrequired1(inputs)
});
export { streetrequired1 as "streetRequired" }